// src/features/owner/sections/analytics/OverviewSection.tsx
import { AnalyticsSection } from './AnalyticsSection';
export const OverviewSection = () => <AnalyticsSection kind="overview" />;
